import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-date-range-status',
  template: `
    <span [class]="styleClass">
      <div [ngClass]="startClass">{{ formattedStart }}</div>
      <ng-container *ngIf="showDash">-</ng-container>
      <div [ngClass]="endClass">{{ formattedEnd }}</div>
    </span>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeStatusComponent implements OnChanges {
  @Input() start!: number | string | Date;
  @Input() end!: number | string | Date;
  @Input() format = 'dd/MM/yyyy';
  @Input() styleClass = '';
  @Input() showDash = false ;

  formattedStart = '';
  formattedEnd = '';
  startClass = '';
  endClass = '';

  constructor(private datePipe: DatePipe) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.start || changes.end || changes.format) {
      this.updateFormattedDates();
      this.updateStatusClasses();
    }
  }

  private updateFormattedDates(): void {
    this.formattedStart = this.datePipe.transform(this.start, this.format) || '';
    this.formattedEnd = this.datePipe.transform(this.end, this.format) || '';
  }

  private updateStatusClasses(): void {
    const now = Date.now();
    const startTime = new Date(this.start).getTime();
    const endTime = new Date(this.end).getTime();

    this.startClass = now >= startTime ? 'text-green-600x' : 'text-red-600';
    this.endClass = now <= endTime ? 'text-green-600x' : 'text-red-600';
  }
}
